import { Routes, Route } from 'react-router-dom';

import { Navigation, NavigationLink } from './Navigation';
import { Page } from './Page';
import Home from './Home';
import PrivacyPolicy from './PrivacyPolicy';

function Application() {
  return (
    <main className="h-screen">
      <h1 className="text-3xl font-bold bg-gradient-to-r from-blue-600 to-indigo-700 text-white p-4 border-b border-gray-200 shadow-sm">
        Elevate Sports Center
      </h1>
      <div className="grid grid-cols-12 grid-rows-1 gap-4 h-[calc(100vh-4rem)]">
        <Navigation>
          <NavigationLink to="/">Home</NavigationLink>
          <NavigationLink to="/privacy">Privacy Policy</NavigationLink>
        </Navigation>
        <section className="col-span-9 p-4 overflow-y-auto">
          <Routes>
            <Route
              path="/notes/beatles"
              element={
                <div>
                  <img
                    src="/beatles.jpg"
                    alt="Possibly the Beatles, possibly"
                  />
                </div>
              }
            />
            <Route path="/notes/:id" element={<Page />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/" element={<Home />} />
          </Routes>
        </section>
      </div>
    </main>
  );
}

export default Application;
